
 import * as React from "react"
 import schemaLogo from "../../../static/home/wowmakers.jpeg"
 const siteUrl = "https://www.wowmakers.com"
 var schemaLogoUrl = siteUrl + schemaLogo
 const SeoHead = ({ogImage, title, description}) => {
    const OrgranizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "WowMakers",
      "description": "We're a 10-year old UI/UX design company specialized in user experience design (UX), user interface design (UI) & mobile and web engineering.",
      "url": "https://www.wowmakers.com/",
      "logo": schemaLogoUrl,
      "contactPoint": [{
        "@type": "ContactPoint",
        "telephone": "+91 484 4869006",
        "contactType": "customer service",
        "areaServed": ["IN","US","CA","SG","QA","AE","SA"],
        "availableLanguage": ["en","Hindi","Malayalam"]
      },{
        "@type": "ContactPoint",
        "telephone": "+91 8113886886",
        "contactType": "sales",
        "areaServed": ["US","GB","CA","IN","SG","QA","AE","SA"],
        "availableLanguage": ["en","Hindi","Malayalam"]
      }],
      "sameAs": [
        "https://www.facebook.com/WowMakers/",
        "https://twitter.com/wowmakers/",
        "https://www.youtube.com/user/wowmakerschannel/",
        "https://www.linkedin.com/company/wowmakers/",
        "https://www.wowmakers.com/",
        "https://www.facebook.com/WowMakers/"
      ]
    }
    const WebsiteSchema = {
      "@context": "https://schema.org/",
      "@type": "WebSite",
      "name": "WowMakers",
      "url": "https://www.wowmakers.com",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://www.wowmakers.com/?s={search_term_string}{search_term_string}",
        "query-input": "required name=search_term_string"
      }
    }

   return (
    <>
        <meta name="robots" content="index, follow" />
        <meta name="CCBot" content="nofollow" />
        <meta name="format-detection" content="telephone=no"></meta>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        {/* <meta property="og:url" content={window.location.href} /> */}
        <meta property="og:type" content="website" />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={siteUrl + ogImage} />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content={title} />
        <meta property="twitter:description" content={description} />
        <meta property="twitter:image" content={siteUrl + ogImage} />    
        <meta name="p:domain_verify" content="1f406c64d26e89ba8339a378728c8388" />
        <meta name="facebook-domain-verification" content="bo90j4stuweedz8vis522ecyeax0xu" />
        <meta name="google-site-verification" content="TKBhz1V7S_jJnOvZ8OXIUXa3TDkXiF1qlm8zlYuZ8mw" />
        <script type="application/ld+json">
          {JSON.stringify(OrgranizationSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(WebsiteSchema)}
        </script>                
    </>
   )
 }
 
 export default SeoHead
 